import store from "../store/store";
import * as contractDuck from "../store/ducks/contract.duck";
import * as contractsDuck from "../store/ducks/contracts.duck";
import * as actionsDuck from "../store/ducks/actions.duck";

export const onNotification_CREATED = () => {
    store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
}

export const onNotification_DRAFT_SAVED = () => {

}

export const onNotification_COMMUNICATED = () => {
    store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_CONTRACT });
    store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
    store.dispatch({ type: contractsDuck.actionTypes.CONTRACTS_SET_PENDING });
    store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });

}
export const onNotification_REPLY_DRAFT_SAVED = () => {

}
export const onNotification_REPLY_SENT = () => {
    store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_CONTRACT });
    store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });
    store.dispatch({ type: contractsDuck.actionTypes.CONTRACTS_SET_PENDING });
    store.dispatch({ type: actionsDuck.actionTypes.ACTIONS_SET_PENDING });
}
export const onNotification_DELETED = () => {
    store.dispatch({ type: contractDuck.actionTypes.CONTRACT_REFRESH_DASHBOARD });

}